import React from 'react'

function FrontFacebookIcon({ width, height, className }) {
    return (
        <svg id="Group_12889_3_" data-name="Group 12889 (3)" xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 22.43 22.43">
            <path id="Path_21042" data-name="Path 21042" d="M22.43,11.215A11.215,11.215,0,1,0,9.463,22.293V14.457H6.615V11.215H9.463V8.744c0-2.811,1.674-4.363,4.236-4.363a17.246,17.246,0,0,1,2.51.219V7.36H14.795a1.621,1.621,0,0,0-1.828,1.751v2.1h3.11l-.5,3.242H12.967v7.837A11.217,11.217,0,0,0,22.43,11.215Z" fill="#1877f2" />
            <path id="Path_21043" data-name="Path 21043" d="M13.684,13.2l.5-3.242h-3.11v-2.1A1.621,1.621,0,0,1,12.9,6.1h1.414V3.344a17.246,17.246,0,0,0-2.51-.219c-2.562,0-4.236,1.553-4.236,4.363V9.959H4.719V13.2H7.566v7.837a11.336,11.336,0,0,0,3.5,0V13.2Z" transform="translate(1.896 1.256)" fill="#fff" />
        </svg>
    )
}

export default FrontFacebookIcon